(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentahoyrealtimeDetailController', VentahoyrealtimeDetailController);

    VentahoyrealtimeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ventahoyrealtime'];

    function VentahoyrealtimeDetailController($scope, $rootScope, $stateParams, previousState, entity, Ventahoyrealtime) {
        var vm = this;

        vm.ventahoyrealtime = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:ventahoyrealtimeUpdate', function(event, result) {
            vm.ventahoyrealtime = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
